import { type RoleUsuario } from '@varga/shared';
import { type ReactNode, useEffect } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { guardarDestino } from '../lib/session';
import { Shell } from './Shell';

/**
 * Rota protegida (UX-PAINEL-INTERNO §0.7):
 * - sem sessão → /login?destino=<rota> (a rota é guardada para voltar depois);
 * - role insuficiente → "Você não tem acesso a esta parte" + link pro Cadastro.
 */
export function RotaProtegida({
  children,
  papel,
}: {
  children: ReactNode;
  papel?: RoleUsuario;
}): ReactNode {
  const { usuario, carregando } = useAuth();
  const local = useLocation();

  useEffect(() => {
    if (!carregando && !usuario) {
      guardarDestino(local.pathname + local.search);
    }
  }, [carregando, usuario, local.pathname, local.search]);

  if (carregando) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-fundo text-nota text-tinta-2">
        Carregando…
      </div>
    );
  }

  if (!usuario) {
    const destino = encodeURIComponent(local.pathname + local.search);
    return <Navigate to={`/login?destino=${destino}`} replace />;
  }

  if (papel && usuario.role !== papel) {
    return (
      <Shell>
        <div className="mx-auto max-w-form py-16 text-center">
          <p className="text-corpo text-tinta-forte">Você não tem acesso a esta parte do painel.</p>
          <Link
            to="/"
            className="mt-3 inline-block font-display text-[0.9375rem] font-bold text-acento-texto underline"
          >
            Ir para Cadastro
          </Link>
        </div>
      </Shell>
    );
  }

  return <Shell>{children}</Shell>;
}
